<template>
  <div class="offer-main">
    <img class="hand" src="../assets/img/shou_question.png" alt="">
    <img class="mo" src="../assets/img/zhen_question.png" alt="">
     <audio  preload="auto" loop="loop" ref="chooseMusic">
        <source src="../assets/audio/choose.mp3">
      </audio>
    <transition name="fade">
      <ul>
        <li
          class="ti-item"
          v-if="flag === item.testFlag"
          v-for="(item,index) in testObj"
          :key="index"
        >
          <img class="order-img" :src="item.orderImg" alt="">
          <div class="ti-title">{{item.title}}</div>
          <img class="footer-right-img" :src="item.imgUrl" alt="">
            <div class="flex-box">
                <div
                    class="ti"
                    @click="getChoose(item,k,i)"
                    :key="i"
                    v-for="(itm,k,i) in item.choose"
                    :style="testStyle(i)"
                    :class="[itmIndex === i?'ti-active':'',i === 3?'marginb-none':'']"
                >
                    <span class="choose-item">{{k}}.</span>
                    <span class="ti-text">{{itm}}</span>
                </div>
            </div>
        </li>
      </ul>
    </transition>
    <div class="modal-main identify-box" v-show="showFlag">
      <div class="modal-bg" @click="identifyMoadl=false"></div>
      <div class="modal-contant modal-lg">
        <div>
          <img src="http://wwj.jijiagames.com//web/act/20190410/loading2.png" alt="">
         <div class="ready-text-box">
            <span class="ready-text" :key="i" v-for="(item,i) in reviceOfferText" :style="redayText(i)">{{item}}</span>
         </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import types from '../store/types';

export default {
    props: ['chooseMusicFlag'],
    data() {
        return {
            obj: {},
            isDisabled: false,
            flag: 1,
            showFlag: false,
            reviceOfferText: '准备接旨吧 !',
            itmIndex: null,
            testObj: {
                first: {
                    order: '第一题',
                    testFlag: 1,
                    orderImg: require('../assets/img/first.png'),
                    title: '入宫第一天你穿什么?',
                    imgUrl: require('../assets/img/painter_question.png'),
                    choose: {
                        A: '优雅的汉服',
                        B: '朴素的平民服饰',
                        C: '设计感Designer服装',
                        D: '名牌但低调的华服'
                    }
                },
                second: {
                    order: '第二题',
                    testFlag: 2,
                    orderImg: require('../assets/img/second.png'),
                    title: '挑事儿精对你提出无理需求,你会说?',
                    imgUrl: require('../assets/img/prime minister_question.png'),
                    choose: {
                        A: '我去帮你问下大人,但估计实现不了',
                        B: '嗯嗯好的,收到',
                        C: '皇家流程走了吗?签字了吗?',
                        D: '亲亲,麻烦给我个详细的brief'
                    }
                },
                third: {
                    order: '第三题',
                    testFlag: 3,
                    orderImg: require('../assets/img/third.png'),
                    title: '皇城里要举办联欢会,你会?',
                    imgUrl: require('../assets/img/engineer_question.png'),
                    choose: {
                        A: '掌控全局,号召大家表演节目',
                        B: '化身女装大佬,我就是舞台王者',
                        C: '默默付出、打杂,布置晚会现场',
                        D: '苦练一首《《领导,我最敬爱的人》》献唱'
                    }
                },
                fourth: {
                    order: '第四题',
                    testFlag: 4,
                    orderImg: require('../assets/img/fourth.png'),
                    title: '掌时姑姑每天约你去吃很贵的御膳后厨,你会?',
                    imgUrl: require('../assets/img/sales_question.png'),
                    choose: {
                        A: '还不如我在外面吃的,以后我不会去了',
                        B: '你还不知道我赚几个钱吗，我吃不起啊',
                        C: '姑姑你好会吃啊 (默默跟着去)',
                        D: '假装肠胃不舒服,自行就餐'
                    }
                },
                fifth: {
                    order: '第五题',
                    testFlag: 5,
                    orderImg: require('../assets/img/fifth.png'),
                    title: '管事大人写了首七言绝句,你觉得很一般,你会说?',
                    imgUrl: require('../assets/img/HR_question.png'),
                    choose: {
                        A: '大人的想法就是我的想法,我觉得很好',
                        B: '大人的文风,我可能不懂',
                        C: '这些地方还可以提升一下 (打开word审阅功能)',
                        D: '诗句精妙,我不明觉厉'
                    }
                }
            },
            answer: []
        };
    },
    mounted() {
    },
    methods: {
        testStyle(index) {
            return {
                animationDelay: `${index / 4 + 0.6}s`
            };
        },
        redayText(index) {
            return {
                animationDelay: `${index / 4 + 0.4}s`
            };
        },
        getChoose(item, key, index) {
            this.itmIndex = index;
            if (this.chooseMusicFlag) {
                this.$refs.chooseMusic.play();
            }
            else if (!this.chooseMusicFlag) {
                this.$refs.chooseMusic.pause();
            }
            if (!this.obj[item.order]) {
                this.obj[item.order] = key;
                this.answer.push(this.obj[item.order]);
            }
            if (this.answer && this.answer.length === 5) {
                this.showFlag = true;
                this.$store.dispatch(types.ancientOffer, this.answer);
                setTimeout(() => {
                    this.$emit('next', 4);
                }, 4000);
                setTimeout(() => {
                    this.$refs.chooseMusic.pause();
                }, 500);
                return;
            }
            setTimeout(() => {
                this.flag = item.testFlag + 1;
                this.itmIndex = null;
                this.$refs.chooseMusic.pause();
                this.$refs.chooseMusic.currentTime = 0;
            }, 500);
        }
    }
};
</script>

<style lang="stylus" scoped>
@font-face
    font-family: 'shuti';
    src:url('/font/shuti.ttf') format('truetype');
.offer-main
    position relative
    font-family shuti !important;
    width: 100%;
    height: 100%;
    font-size: 0.3rem;
    background url("http://wwj.jijiagames.com//web/act/20190410/BG_question.jpg") 0 0/100% 100% no-repeat
    padding-top 1.35rem
    .hand
        position absolute
        left 0
        bottom 0
    .mo
        position absolute
        top 0.26rem
        right 0
    .ti-item
        width 5.39rem
        margin 0 auto
        -webkit-animation-name: fadeInOut
        -webkit-animation-timing-function: ease
        -webkit-animation-duration: 2s
        -webkit-animation-direction: alternate
        .order-img
            margin-bottom 0.6rem
        .ti-title
            font-family shuti !important;
            font-size 0.45rem
            height 1.3rem
            text-align center
        .footer-right-img
            animation down 1s ease-out infinite
            position absolute
            bottom 0
            right 0
        .flex-box
            .ti
                flex-grow 1
                box-sizing border-box
                padding 0.26rem 0 0.25rem 0.4rem
                -webkit-backface-visibility: hidden
                animation: show 0.5s
                animation-delay: 0.5s
                animation-fill-mode: forwards
                opacity: 0
                .choose-item
                    font-size 0.36rem
                    font-family shuti !important
                .ti-text
                    font-family shuti !important
                    font-size 0.36rem
            .ti-active
                background url("../assets/img/Choice_question.png") left -3% no-repeat
    @keyframes show
        from
            opacity: 0;
        to
            opacity: 1;
    @keyframes down
        0%
            transform translateY(0)
        30%
            transform translateY(-4px)
        50%
            transform translateY(-5px)
        10%
            transform translateY(0px)
    @keyframes fadeInOut
        0%
            opacity: 0;
        50%
            opacity: 0.6;
        75%
            opacity: 0.8;
        100%
            opacity: 1;
    .marginb-none
        margin-bottom 0 !important
    .ready-text-box
        position absolute
        top 4rem
        left 2.2rem
    .ready-text
        -webkit-backface-visibility: hidden
        font-family shuti !important
        font-size 0.44rem
        font-weight 600
        animation: show 0.4s
        animation-delay: 0.4s
        animation-fill-mode: forwards
        opacity: 0
  // 模态框
  .modal-main
    position: absolute
    top: 0
    left:0
    width: 100%
    z-index: 9999
    height: 100%
  .modal-bg
    width: 100%
    height: 100%
    background: #000
    opacity: 0.7
    z-index: 9998
    left: 0
    right: 0
    top: 0;
    bottom: 0;
  .modal-dialog
    width: 100%;
    height: 100%;
    position: relative;
  .modal-contant
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translateX(-50%) translateY(-50%);
    z-index: 9999;
    margin: auto;
    @include rounded(10px);
  .modal-header
    position: relative;
    background: $blue;
    height: 1rem;
    line-height: 1rem;
    font-size: 0.5rem;
    text-align: center;
    color: #fff;
    border-radius: 10px 10px 0 0;
  .modal-body
    width: 100%;
    box-sizing: border-box;
    padding: 0.5rem;
    overflow: auto;
</style>
